<template>
  <div class="YuanAIBox">
    <div class="titleBox">
      <img class="allImage" :src="firstPhoto" alt="" />
      <div class="ImgOrText">
        <img :src="textYuanAI" alt="" />
        <p>
          一个功能强大的多模态交互平台，具备AI问答功能，数字人能够理解用户的问题和
          指令，快速给出准确的回答和响应，还可以通过人脸识别对指定用户进行主动问好
          针对不同客户，可以根据需求定制数字人及专属语料库，深度贴合各行业应用场景
          无论是智能客服、教育培训，还是企业办公、市场营销等领域，都能凭借其卓越性
          能与高度定制化服务，助力企业提升竞争力与服务品质，开启数字化交互全新篇章
        </p>
      </div>
    </div>
    <div class="ImgOrText2">
      <img :src="textgnzs" alt="" />
      <!-- <p style="font-weight: bold">AI智能问答</p> -->
      <Carousel class="carousel"></Carousel>
    </div>
    <div class="ImgOrText2">
      <p class="pp" style="font-weight: bold">AI视频制作</p>
    </div>
    <div class="allImage fl">
      <video
        class="video"
        :src="Yuan"
        autoplay
        loop
        playsinline
        muted
        poster=""
        controlslist="nodownload"
        preload="none"
      ></video>
    </div>
        <div class="ImgOrText2">
      <p class="pp" style="font-weight: bold">AI多态交互</p>
    </div>
    <div class="allImage fl">
      <video
        class="video"
        :src="Yuanai"
        autoplay
        loop
        playsinline
        muted
        poster=""
        controlslist="nodownload"
        preload="none"
      ></video>
    </div>
    <div class="titleBox">
      <img class="allImage" :src="mid" alt="" />
      <div class="ImgOrText">
        <img class="aiznImg" style="margin-left: 80px" :src="AIZN" alt="" />
        <p>
          一个功能强大的多模态交互平台，具备AI问答功能，数字人能够理解用户的问题和
          指令，快速给出准确的回答和响应，还可以通过人脸识别对指定用户进行主动问好
          针对不同客户，可以根据需求定制数字人及专属语料库，深度贴合各行业应用场景
          无论是智能客服、教育培训，还是企业办公、市场营销等领域，都能凭借其卓越性
          能与高度定制化服务，助力企业提升竞争力与服务品质，开启数字化交互全新篇章
        </p>
      </div>
    </div>
    <div class="ImgOrText2">
      <img class="aijs_img" :src="AIJS" alt="" />
      <p
        class="aijs_p"
        style="position: absolute; bottom: 0; right: -14px; font-size: 1.5rem"
      >
        提升学习效率, 数据分析剖析学习难题，个性化辅导促进步
      </p>
    </div>
    <div class="ImgAIjiaoshi">
      <img :src="AIjiaoshi001" alt="" />
    </div>
    <div class="ImgAIjiaoshi" style="padding-top: 0; padding-bottom: 0">
      <img :src="AIjiaoshi002" alt="" />
    </div>
    <div class="ImgOrText2">
      <img class="ImgOrText2_img" :src="AISZR" alt="" />
    </div>
    <div class="YuanFooterMain">
      <div class="YuanFooter">
        <div class="YuanFooter_left">
          <img :src="xiaomei" alt="" />
        </div>
        <div class="YuanFooter_right">
          <div class="line"></div>
          <p>
            从文旅先贤系列的东方数字人朱熹，到承载西域神秘的楼兰姑娘，再到敦煌的首个官方数字人，每一个数字形象
            都仿若一颗璀璨星辰。它们以超写实的外观、灵动的交互性以及丰富的文化内涵脱颖而出，不仅是科技与艺术的
            结晶，更是连接古今跨越地域文化界限的桥梁，为文化传播、品牌推广、文旅融合等多元领域注入全新活力，开
            启数字化体验的无限可能
          </p>
          <ul>
            <li v-for="(v, k) in footerList" :key="k">
              <img :src="v.url" alt="" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="ys"></div>
    <!-- <div class="titleBox">
      <h1>功能展示</h1>
      <h5>拥有便捷及丰富的会员管理功能,可通过人脸准确识别会员,并与之主动交互</h5>
      <div class="secBox">
        <img v-for="(v, k) in imgList" :key="k" class="allImage" :src="v.url" alt="" />
      </div>
    </div> -->
    <!-- <div class="titleBox">
      <h1>AI教师</h1>
      <h5>
        专注教育个性化智能推荐系统匹配学生水平,精准推送课程与习题,提升学习效率。数据分析剖析学习难题
      </h5>
      <h5>
        个性化辅导促进步。同时,智能化辅助教学管理,减轻教师负担,专注学生成长,共推教育质量飞跃。
      </h5>
      <img class="allImage mt" :src="thePhoto" alt="" />
    </div> -->
    <!-- <div class="titleBox" style="padding-bottom: 40px">
      <h1>AI数字人</h1>
      <h5>推出朱熹与楼兰女数字形象,融合科技与文化</h5>
      <h5>朱熹智能问答展儒家智慧,楼兰女则智能交流解历史之谜</h5>
      <h5>两者象征技术实力,突破智能问答领域,融合传统与现代,启迪用户</h5>
      <div class="secBox">
        <img
          v-for="(v, k) in footerImgBox"
          :key="k"
          class="allImage"
          :src="v.url"
          alt=""
        />
      </div>
    </div> -->
  </div>
</template>

<script setup>
import AIjiaoshi001 from "@/assets/YuanAI/AIjiaoshi001.webp";
import xiaomei from "@/assets/YuanAI/xiaomei.webp";
import AIjiaoshi002 from "@/assets/YuanAI/AIjiaoshi002.webp";
import AIZN from "@/assets/YuanAI/AIZN.webp";
import AISZR from "@/assets/YuanAI/AISZR.webp";
import AIJS from "@/assets/YuanAI/AIJS.webp";
import Carousel from "@/components/slide.vue";
import Yuanai from "@/assets/YuanAI/yuanai.mp4";
import Yuan from "@/assets/YuanAI/yuan.mp4";
import { ref } from "vue";
import thePhoto from "@/assets/thePhoto.webp";
import firstPhoto from "@/assets/YuanAI/banner.webp";
import mid from "@/assets/YuanAI/mid.webp";
import textYuanAI from "@/assets/YuanAI/YuanAI.webp";
import textgnzs from "@/assets/YuanAI/gnzs.webp";
import text1 from "@/assets/YuanAI/1.webp";
import text2 from "@/assets/YuanAI/2.webp";
import text3 from "@/assets/YuanAI/3.webp";
import text4 from "@/assets/YuanAI/4.webp";
import text5 from "@/assets/YuanAI/5.webp";
const footerList = ref([
  { url: text1 },
  { url: text2 },
  { url: text3 },
  { url: text4 },
  { url: text5 },
]);
</script>
<style scoped lang="scss">
.slide-li {
  text-align: center;
  font-size: 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.slide-li:nth-child(1) {
  background: #01ad59;
  color: #fff;
}
.slide-li:nth-child(3) {
  background: #eaaba2;
  color: #fff;
}
@import "./index.scss";
</style>
